import { ref, onMounted, onUnmounted } from 'vue';
import { useLocalStorageStore } from '@base-shared/stores/local-storage';

const isSideNavCollapsed = ref(false);
let initialized = false;

const handleResize = () => {
  // Prefer explicit user setting from localStorage
  const savedState = useLocalStorageStore().getSidebarCollapseFromStorage();
  if (savedState !== null) {
    isSideNavCollapsed.value = savedState;
    return;
  }

  // Collapse if window is small (<= 1280px)
  const shouldCollapse = window.innerWidth <= 1280;
  if (isSideNavCollapsed.value !== shouldCollapse) {
    isSideNavCollapsed.value = shouldCollapse;
  }
};

export function useSideNavCollapse() {
  if (!initialized) {
    initialized = true;

    onMounted(() => {
      handleResize();

      if (useLocalStorageStore().getSidebarCollapseFromStorage() === null) {
        window.addEventListener('resize', handleResize);
      }
    });

    onUnmounted(() => {
      window.removeEventListener('resize', handleResize);
    });
  }

  const collapseSideNav = (collapsed: boolean) => {
    isSideNavCollapsed.value = collapsed;
  };

  const userToggle = () => {
    const collapsed = !isSideNavCollapsed.value;
    collapseSideNav(collapsed);
    useLocalStorageStore().setSidebarCollapseInStorage(collapsed);
    window.removeEventListener('resize', handleResize);
  };

  return {
    isSideNavCollapsed,
    collapseSideNav,
    userToggle
  };
}
